import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24.445",
  height: "24.444",
  viewBox: "0 0 24.445 24.444"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  id: "Groupe_974",
  "data-name": "Groupe 974",
  transform: "translate(-8298.385 -17321.995)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Tracé_1771",
    "data-name": "Tracé 1771",
    d: "M56.831,27.439A12.222,12.222,0,1,1,69.054,15.217,12.236,12.236,0,0,1,56.831,27.439m0-22.444A10.222,10.222,0,1,0,67.054,15.217,10.233,10.233,0,0,0,56.831,4.995",
    transform: "translate(8253.776 17319)",
    fill: "#fff"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Tracé_1772",
    "data-name": "Tracé 1772",
    d: "M54.258,21.359V9.076l7.069,6.141Zm2-7.9v3.509l2.021-1.755Z",
    transform: "translate(8253.776 17319)",
    fill: "#fff"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}